import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { filter, map, mergeMap, tap } from 'rxjs';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { LocationService } from '@core/jss-seo';
import { FehApiActions } from '@feh/shared-api';

import { sustainabilityRabobankId } from './rabobank-form.reducer';
import {
  submitRabobankForm,
  submitRabobankFormSuccess,
} from './rabobank-form.actions';
import { selectRabobankRedirectUrl } from './rabobank-form.selectors';
import { clearTimeslots } from '../get-timeslots';

@Injectable()
export class RabobankFormEffects {
  private readonly actions$ = inject(Actions);
  private readonly store = inject(Store);
  private readonly location = inject(LocationService);

  submitForm$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(submitRabobankForm),
      map(({ payload }) =>
        FehApiActions.postThirdpartyV1.requestAction({
          actionId: sustainabilityRabobankId,
          payload,
        })
      )
    );
  });

  handleCreateLeadSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FehApiActions.postThirdpartyV1.successAction),
      filter((params) => params.actionId === sustainabilityRabobankId),
      concatLatestFrom(() => [this.store.select(selectRabobankRedirectUrl)]),
      tap(([_, redirectUrl]) => {
        this.location.navigateGeneralLink(redirectUrl?.value?.href as string);
      }),
      mergeMap(() => [clearTimeslots(), submitRabobankFormSuccess()])
    )
  );
}
